/**
 * AI 分析 - 成功路径时间线
 */
import React from 'react';
import { Card, Space, Timeline, Typography, Tag } from 'antd';
import { RocketOutlined, CheckOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface SuccessPhase {
  phase: string;
  actions: string[];
  investment: string;
  goals: string[];
}

interface AISuccessPathProps {
  successPath: SuccessPhase[];
}

export const AISuccessPath: React.FC<AISuccessPathProps> = ({ successPath }) => {
  return (
    <Card
      title={
        <Space>
          <RocketOutlined style={{ color: '#1890ff' }} />
          成功路径
        </Space>
      }
      className="ai-content-card"
    >
      <Timeline
        className="success-timeline"
        items={successPath.map((phase, index) => ({
          color: 'blue',
          children: (
            <div className="success-phase-card">
              <div className="success-phase-title">{phase.phase}</div>
              <div className="success-phase-section">
                <span className="success-phase-label">💰 投入资源</span>
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  {phase.investment}
                </Text>
              </div>
              <div className="success-phase-section">
                <span className="success-phase-label">📋 行动计划</span>
                <ul className="success-phase-actions">
                  {phase.actions.map((action, i) => (
                    <li key={i}>{action}</li>
                  ))}
                </ul>
              </div>
              <div className="success-phase-section">
                <span className="success-phase-label">🎯 目标成果</span>
                <div className="success-phase-goals">
                  {phase.goals.map((goal, i) => (
                    <Tag key={i} color="blue" icon={<CheckOutlined />}>
                      {goal}
                    </Tag>
                  ))}
                </div>
              </div>
            </div>
          ),
        }))}
      />
    </Card>
  );
};

